import React from 'react';
import { AppBar } from '../../../../@components/bars';
import { Rules } from '../../components/Rules';

export const RulesPage = () => (
  <>
    <AppBar deep />
    <Rules />
  </>
);
